export default __webpack_public_path__ + "images/trolley.82bdf9d.svg";